<template>
  <header class="container-fluid">
    <slot></slot>
    <section class="slider">
      <div class="sw" style="height: 100%">
        <swiper slidesPerView="1" spaceBetween="0" :pagination="{ clickable: true }"
          style="height: 83vh;  max-height: 722px !important;" :modules="[Navigation, Pagination]">
          <swiper-slide v-for="item in slider" :key="item.img" style="height: 83vh;  max-height: 722px !important;">
            <img :src="item.img" alt="" class="content slide1 object-cover" :style="'height: 83vh;  max-height: 722px!important; object-fit: cover;'">
          </swiper-slide>
        </swiper>
      </div>
    </section>
  </header>
</template>
<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css/bundle'

const slider = ref([
  {
    img: "/rsz_11rsz_img_7070.jpg",
    h: "Бесплатная парковка",
    p: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
  },
  {
    img: "/rsz_img_7026.jpg",
    h: "Бесплатная парковка",
    p: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
  }
])

const swiperOption = ref({
  spaceBetween: 0,
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
})
</script>

<style scoped>
header {
  height: 83vh;
  max-height: 722px !important;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: none;
  display: flex;
  align-items: flex-start;
  align-content: space-between;
  padding-top: 30px;
}

@media screen and (max-width: 1199px) {
  .sw {
    display: none;
  }

  header {
    height: 66px !important;
    margin-bottom: 27px;
  }
}

header .slider {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1;
  height: 83vh;
  max-height: 722px;
  overflow: hidden;
}

.content {
  height: 100%;
  width: 100%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: none;
}

.absolute {
  position: absolute;
  display: block;
  bottom: 100px;
  left: 200px;
}

.text {
  position: relative;
  background-color: rgba(255, 255, 255, 0.84);
  z-index: 3;
  padding: 45px;
  width: 454px;
}

.text h3 {
  font-family: "Didot";
  font-size: 34px;
  font-weight: 400;
  font-style: normal;
  margin-top: -8px;
}

.text p {
  font-family: "Lato";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-top: 10px;
  margin-bottom: -4px;
}

.borders-1 {
  position: absolute;
  left: 25px;
  right: -25px;
  top: -25px;
  bottom: 100%;
  border-top: 2px solid #d9ccaf;
  border-left: 2px solid #d9ccaf;
}

.borders-2 {
  position: absolute;
  left: 100%;
  right: -25px;
  top: -25px;
  bottom: 25px;
  border-right: 2px solid #d9ccaf;
  border-bottom: 2px solid #d9ccaf;
}
</style>

<style>
.swiper-container {
  height: 100%;
}

.swiper-button-prev {
  background-image: url("/img/arrow_left.svg") !important;
}

.swiper-button-next {
  background-image: url("/img/arrow_right.svg") !important;
}

.swiper-pagination-bullet {
  background-color: #d9ccaf;
  opacity: 1;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: 0.6s;
  outline: none !important;
}

.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: white;
}

.swiper-slide {
  height: auto;
  width: auto;
  min-height: 100%;
  min-width: 100%;
}

header .slider {
  margin: 0 !important;
}
</style>
